// Compat: reexporta el slice actual hasta completar la migración del dominio
export * from '../ViewInventory/inventorySlice'
export { default } from '../ViewInventory/inventorySlice'
